import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取合同列表
 * @param params
 */
export const getContractListApi = (params:object) => $http.get('/channel/get_channel_contact_list', params)

/**
 * 保存合同信息
 * @param data
 */
export const saveContractApi = (data:object) => $http.post('/channel/do_contract', data)

/**
 * 获取合同详情
 * @param params
 *      id：合同 id（可选）
 *      channel_no：渠道号（可选）
 */
export const getContractDetailApi = (params:object) => $http.post('/channel/get_contractifo', params)

/**
 * 删除合同
 * @param params
 *  id: 合同 id
 */
export const delContract = (id:any) => $http.post('/channel/del_contract', {id})


/**
 * 保存合同提醒人
 * @param data
 */
export const saveContractWarningApi = (data:object) => $http.post(`/channel/remind_user`, data)

/**
 * 获取合同提醒人数据
 */
export const getContractWarningApi = () => $http.get('/channel/get_remind_list')